import axios from 'axios'
import store from '@/store'
import router from '@/router'
const API_URL = process.env.VUE_APP_API_HOST_DOMAIN
const API_TOKEN_NAME = process.env.VUE_APP_ENV_COMPANY_NAME + '-api-token'
const headers = {
    'Content-Type': 'application/json; charset=utf-8'
}
const formDataHeaders = {
    'Content-Type': 'multipart/form-data'
}
export default {
    post(urlPath, data) {
        return this.request(urlPath, 'POST', headers, data)
    },
    put(urlPath, data) {
        return this.request(urlPath, 'PUT', headers, data)
    },
    get(urlPath) {
        return this.request(urlPath, 'GET', headers, null)
    },
    delete(urlPath) {
        return this.request(urlPath, 'DELETE', headers, null)
    },
    getFile(urlPath, fileName) {
        window.open(API_URL + urlPath, '_blank')
    },
    uploadFile(urlPath, formData) {
        return this.request(urlPath, 'POST', formDataHeaders, formData)
    },
    uploadImage(urlPath, formData) {
        return this.fetchRequest(urlPath, 'POST', formDataHeaders, formData)
    },
    request(urlPath, method, headers, data) {
        data = data || {}
        const apiToken = sessionStorage.getItem(API_TOKEN_NAME)
        if (apiToken) {
            headers = {
                ...headers
            }
            if (urlPath !== `users/login`) {
                headers.Authorization = 'Bearer ' + apiToken
            }
        }

        return new Promise((resolve, reject) => {
            axios({
                url: API_URL + '/' + urlPath,
                data: data,
                method: method,
                headers: headers
            }).then(response => {
                resolve(response)
            }).catch((error) => {
                reject(error)
                if (error.response.status === 423) {
                    store.dispatch('logout').then(() => router.push({ path: '/login' }))
                }
            })
        })
    },
    async fetchRequest(urlPath, method, headers, data) {
        const apiToken = sessionStorage.getItem(API_TOKEN_NAME)
        headers = { ...headers }
        if (apiToken && urlPath !== 'users/login') {
            headers.Authorization = 'Bearer ' + apiToken
        }
        if (data instanceof FormData) {
            delete headers['Content-Type']
        }
        try {
            const response = await fetch(API_URL + '/' + urlPath, {
                method,
                headers,
                body: data
            })
            if (!response.ok) {
                if (response.status === 423) {
                    await store.dispatch('logout')
                    router.push({ path: '/login' })
                }
                throw new Error(`HTTP error! status: ${response.status}`)
            }
            return await response.json()
        } catch (error) {
            throw error
        }
    }
}
